import dayjs from 'dayjs';

import { getEnTranslation, getFrTranslation } from 'utils';

import { offerStore, offerStoreValues } from './offerStore';
import { IOfferStoreActions } from './types';

export const initOfferSuccessAction: IOfferStoreActions['initOfferSuccessAction'] = (data) => {
  const {
    name,
    order,
    items,
    miles,
    status,
    regions,
    quantity,
    offerCode,
    displayFrom,
    rewardScope,
    sponsorCode,
    effectiveTo,
    translations,
    effectiveFrom,
    isParticipation,
    imageMetadataId,
    displayRetailers,
    displayPriorityZoneId,
    maxRedeemsPerCollector,
    isExclusiveForRetailer,
    isRiceCalculationEnabled,
    receiptAcceptanceDaysThreshold,
  } = data;

  offerStore.setState({
    order,
    status,
    imgId: imageMetadataId,
    selectItems: items?.map((item) => ({ label: item.name, value: item.id })),
    selectedItemId: items?.length && items[0].id,
    initialValues: {
      enValues: getEnTranslation(translations) || {},
      frValues: getFrTranslation(translations) || {},
      retailersValue: {
        isExclusiveForRetailer,
        // select multiple or not
        displayRetailers: isExclusiveForRetailer && displayRetailers
          ? displayRetailers[0].id
          : displayRetailers?.map(({ id }) => id),
      },
      zoneValue: {
        displayPriorityZoneId,
      },
      genericValues: {
        name,
        regions,
        quantity,
        rewardScope,
        isParticipation,
        maxRedeemsPerCollector,
        receiptAcceptanceDaysThreshold,
        displayFrom: displayFrom && dayjs(displayFrom) as unknown as string,
        effectiveTo: effectiveTo && dayjs(effectiveTo) as unknown as string,
        effectiveFrom: effectiveFrom && dayjs(effectiveFrom) as unknown as string,
      },
      milesConfigurationValues: {
        miles,
        offerCode,
        sponsorCode,
        isRiceCalculationEnabled,
      },
    },
  });
};

export const updateOfferSelectedItemAction: IOfferStoreActions['updateOfferSelectedItemAction'] = (selectedItemId) => {
  offerStore.setState({ selectedItemId });
};

export const initOfferIdentitiesSuccessAction: IOfferStoreActions['initOfferIdentitiesSuccessAction'] = (identities) => {
  offerStore.setState({ identities });
};

export const resetOfferAction: IOfferStoreActions['resetOfferAction'] = () => {
  offerStore.setState(offerStoreValues);
};
